import { render } from "./WhatsAppUsage.vue?vue&type=template&id=5c2588fe&scoped=true"
import script from "./WhatsAppUsage.vue?vue&type=script&lang=js"
export * from "./WhatsAppUsage.vue?vue&type=script&lang=js"

import "./WhatsAppUsage.vue?vue&type=style&index=0&id=5c2588fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2588fe"]])

export default __exports__